
<div class="row">
    <div class="col-12">

        <!-- title -->
        <div class="title">
            <h5> Вы действительно хотите удалить файл? </h5>
        </div>

        <!-- content -->
        <div class="content">

            <!-- errors -->
            <!-- <div class="errors" *ngIf="productInfoError.message == 'ERROR'">
                <span> {{ productInfoError.result }} </span>
            </div> -->

            <!-- info -->
            <div class="info">
                <ul *ngFor="let info of deleteFileInfo">
                    <li> Данный файл <b>{{ info.name }}</b> используется в {{ info.count }} товар(ах) </li>
                </ul>
            </div>

        </div>

        <!-- buttons -->
        <div class="buttons">

            <!-- close -->
            <button type="button" class="btn btn-back btn-light" (click)="activeModal.close(false)">
                Нет
            </button>

            <!-- delete -->
            <button type="button" class="btn btn-create btn-primary" (click)="onConfirmDelete()" [disabled]="checkPermission()">
                Да
            </button>

        </div>

    </div>
</div>
